// Centrale content voor Klusbedrijf Pruijn

export const COMPANY = {
  name: "Klusbedrijf Pruijn",
  phone: "06 53 42 29 01",
  phoneRaw: "+31653422901",
  whatsapp: "31653422901",
  email: "info@klusbedrijfpruijn.nl",
  website: "www.klusbedrijfpruijn.nl",
  location: "Huissen, Gelderland",
  kvk: "98847228",
  btw: "NL868669246B01",
  instagram: "https://www.instagram.com/klusbedrijfpruijn",
  facebook: "https://www.facebook.com/share/1BGMAKs74B/",
  tiktok: "https://www.tiktok.com/@klusbedrijfpruijn",
  google: "https://share.google/SlbANsXgIMP1FhKo3",
  logo: "/assets/logo.webp",
};

export const NAV_LINKS = [
  { label: "Home", id: "home" },
  { label: "Over ons", id: "over-ons" },
  { label: "Diensten", id: "diensten" },
  { label: "Projecten", id: "projecten" },
  { label: "Werkwijze", id: "werkwijze" },
  { label: "Reviews", id: "reviews" },
  { label: "Contact", id: "contact" },
];

export const SERVICES = [
  { icon: "Hammer", title: "Renovaties", text: "Complete renovaties van A tot Z, vakkundig uitgevoerd." },
  { icon: "Bath", title: "Badkamers", text: "Luxe badkamers volledig op maat ontworpen en aangelegd." },
  { icon: "Toilet", title: "Toiletten", text: "Strakke, moderne toiletruimtes met oog voor detail." },
  { icon: "Layers", title: "PVC vloeren", text: "Hoogwaardige PVC vloeren strak en duurzaam gelegd." },
  { icon: "Grid2x2", title: "Laminaat", text: "Laminaatvloeren professioneel geplaatst in elke ruimte." },
  { icon: "Ruler", title: "Timmerwerk", text: "Maatwerk timmerwerk met precisie en vakmanschap." },
  { icon: "Paintbrush", title: "Schilderwerk", text: "Strak schilderwerk binnen en buiten, perfecte afwerking." },
  { icon: "Square", title: "Kozijnen", text: "Plaatsen en vervangen van kozijnen, hout of kunststof." },
  { icon: "DoorOpen", title: "Deuren", text: "Binnen- en buitendeuren inclusief stalen deuren op maat." },
  { icon: "Home", title: "Veranda's", text: "Sfeervolle veranda's voor optimaal buitenleven." },
  { icon: "ThermometerSnowflake", title: "Isolatie", text: "Effectieve isolatie voor comfort en energiebesparing." },
  { icon: "Wrench", title: "Onderhoud", text: "Periodiek onderhoud zodat uw woning in topconditie blijft." },
  { icon: "Pickaxe", title: "Sloopwerk", text: "Veilig en netjes sloopwerk als basis voor uw verbouwing." },
  { icon: "Sparkles", title: "Afwerking", text: "De perfecte finishing touch op elk renovatieproject." },
];

export const PROJECTS = [
  {
    slug: "complete-woningrenovatie-arnhem",
    title: "Complete woningrenovatie",
    location: "Arnhem",
    work: "Renovatie, PVC vloer, schilderwerk, maatwerk",
    description:
      "Een volledige metamorfose van een gedateerde woning naar een moderne, lichte leefomgeving. Van sloopwerk tot de laatste afwerking hebben wij het volledige traject begeleid. De bewoners genieten nu van een strak afgewerkte woning met hoogwaardige materialen en een tijdloze uitstraling.",
    cover: "https://images.unsplash.com/photo-1724582586529-62622e50c0b3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    before: "https://images.unsplash.com/photo-1581858726788-75bc0f6a952d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    after: "https://images.unsplash.com/photo-1628744876497-eb30460be9f6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    slug: "luxe-badkamer-huissen",
    title: "Luxe badkamer",
    location: "Huissen",
    work: "Badkamer, tegelwerk, installatie, afwerking",
    description:
      "Een complete badkamerrenovatie met luxe natuurlijke materialen, een inloopdouche en strakke detaillering. Wij verzorgden het volledige traject: van sloop en installatie tot het tegelwerk en de finishing touch. Het resultaat is een serene, hotelwaardige badkamer.",
    cover: "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    before: "https://images.unsplash.com/photo-1620626011761-996317b8d101?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    after: "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    slug: "moderne-woonkamer-nijmegen",
    title: "Moderne woonkamer & PVC vloer",
    location: "Nijmegen",
    work: "PVC vloer, stalen deuren, maatwerk, schilderwerk",
    description:
      "Een eigentijdse woonkamer voorzien van een warme PVC vloer, industriële stalen taatsdeuren en maatwerk kasten. Het strakke kleurenpalet en de doordachte verlichting geven de ruimte een exclusieve, rustige uitstraling.",
    cover: "https://images.pexels.com/photos/7045908/pexels-photo-7045908.jpeg?auto=compress&cs=tinysrgb&w=1600",
    before: "https://images.unsplash.com/photo-1505691938895-1758d7feb511?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    after: "https://images.pexels.com/photos/7045908/pexels-photo-7045908.jpeg?auto=compress&cs=tinysrgb&w=1200",
  },
];

export const PROCESS = [
  { step: "01", title: "Kennismaking", text: "We bespreken uw wensen en bekijken de mogelijkheden ter plaatse." },
  { step: "02", title: "Offerte", text: "U ontvangt een heldere, transparante offerte zonder verrassingen." },
  { step: "03", title: "Planning", text: "We stellen een strakke planning op die past bij uw situatie." },
  { step: "04", title: "Uitvoering", text: "Vakkundige uitvoering met één vast aanspreekpunt." },
  { step: "05", title: "Oplevering", text: "Nette oplevering en een woning waar we samen trots op zijn." },
];

export const WHY_US = [
  { icon: "User", title: "Eén aanspreekpunt", text: "Van begin tot eind één vaste contactpersoon die alles regelt." },
  { icon: "MessagesSquare", title: "Heldere communicatie", text: "Korte lijnen en duidelijke afspraken, u weet altijd waar u aan toe bent." },
  { icon: "CalendarCheck", title: "Strakke planning", text: "We houden ons aan de planning en werken efficiënt en netjes." },
  { icon: "Award", title: "Hoogwaardige afwerking", text: "Wij leveren uitsluitend werk af waar we zelf trots op zijn." },
];

export const REVIEWS = [
  {
    name: "Mark Hendriks",
    location: "Arnhem",
    avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?crop=entropy&cs=srgb&fm=jpg&q=85&w=200",
    text: "Onze complete woning is gerenoveerd door Pruijn. Vakwerk, nette communicatie en alles binnen planning opgeleverd. Echt een aanrader!",
  },
  {
    name: "Linda de Vries",
    location: "Huissen",
    avatar: "https://images.unsplash.com/photo-1506863530036-1efeddceb993?crop=entropy&cs=srgb&fm=jpg&q=85&w=200",
    text: "Prachtige badkamer geplaatst. Strak afgewerkt en meegedacht over het ontwerp. We zijn ontzettend tevreden met het resultaat.",
  },
  {
    name: "Tom Jansen",
    location: "Nijmegen",
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?crop=entropy&cs=srgb&fm=jpg&q=85&w=200",
    text: "PVC vloer en stalen deuren laten plaatsen. Perfecte afwerking en een betrouwbaar team. Duidelijke offerte en geen verrassingen.",
  },
];

export const WORK_AREAS = [
  "Arnhem", "Huissen", "Bemmel", "Nijmegen",
  "Duiven", "Westervoort", "Elst", "Lingewaard",
];

export const INSTAGRAM = [
  "https://images.unsplash.com/photo-1628744876497-eb30460be9f6?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
  "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
  "https://images.pexels.com/photos/7045908/pexels-photo-7045908.jpeg?auto=compress&cs=tinysrgb&w=600",
  "https://images.unsplash.com/photo-1628745277862-bc0b2d68c50c?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
  "https://images.unsplash.com/photo-1505691938895-1758d7feb511?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
  "https://images.unsplash.com/photo-1620626011761-996317b8d101?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
];
